import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StandardApiResponse } from '@app/interfaces/standard-api-response';
import { ObjectResultModel, UnitAuthInfo } from '@app/models';
import { FiscalYearMonthStatusModel } from '@app/models/system-settings';
import { IValidateDatesCanPostRequest } from '../models';
import { ApiResponse } from '../models/common';
import { FiscalYearWithDates, FiscalYears } from '../models/unit';

@Injectable({
	providedIn: 'root',
})
export class UnitService {
	endpointBase = '/api/unit';

	constructor(private readonly http: HttpClient) {}

	public getAuthInfo(): Observable<UnitAuthInfo> {
		return this.http.get<UnitAuthInfo>(`${this.endpointBase}/get-auth-info`);
	}

	public getUnit(): Observable<any> {
		return this.http.get(`${this.endpointBase}/get-unit`);
	}

	public saveUnit(unit: any): Observable<any> {
		return this.http.post(`${this.endpointBase}/save-unit`, unit);
	}

	public queueCreateFiscalYear(fiscalYear: number): Observable<any> {
		return this.http.post(`${this.endpointBase}/queue-create-fiscal-year`, fiscalYear);
	}

	public queueUpdateFiscalYears(paramsModel: FiscalYearMonthStatusModel[]): Observable<any> {
		return this.http.post(`${this.endpointBase}/queue-update-fiscal-years`, paramsModel);
	}

	public getValue(key: string): Observable<any> {
		return this.http.get(`${this.endpointBase}/getValue`, { params: { key } });
	}

	public getFiscalYears(): Observable<FiscalYears> {
		return this.http.get<FiscalYears>(`${this.endpointBase}/getFiscalYears`);
	}

	public getFiscalYearsWithDates() {
		return this.http.get<ApiResponse<'fiscalYears', FiscalYearWithDates[]>>(`${this.endpointBase}/getFiscalYearsWithDates`);
	}

	public getCurrentFiscalYearStartAndEndDates(): Observable<any> {
		return this.http.get(`${this.endpointBase}/getCurrentFiscalYearStartAndEndDates`);
	}

	public getCurrentFiscalYear(): Observable<any> {
		return this.http.get(`${this.endpointBase}/getCurrentFiscalYear`);
	}

	public getFiscalMonthYearFromCalendarMonthYear(calendarMonth: number, calendarYear: number): Observable<any> {
		return this.http.get(`${this.endpointBase}/getFiscalMonthYearFromCalendarMonthYear`, {
			params: { calendarMonth: calendarMonth.toString(), calendarYear: calendarYear.toString() },
		});
	}

	public getNextVendorCode(): Observable<StandardApiResponse<string>> {
		return this.http.get<StandardApiResponse<string>>(`${this.endpointBase}/get-next-vendor-code`);
	}

	public validateDatesCanPost(validateDatesCanPostRequest: IValidateDatesCanPostRequest): Observable<ObjectResultModel> {
		return this.http.post<ObjectResultModel>(`${this.endpointBase}/validate-dates-can-post`, validateDatesCanPostRequest);
	}

	getFiscalMonths() {
		return this.http.get<ApiResponse<'fiscalMonths', string[]>>(this.endpointBase + '/getFiscalMonths');
	}
}
